module.exports = require('./helpers/bundle-url').getBundleURL('20yJn') + "logo.7718c6df.svg";